import { createContext, useState } from "react";

export const SearchingDataContext = createContext(null);

export const SearchingDataProvider = ({ children }) => {
  const [searchingData, setSearchingData] = useState("");
  const [isRefresh, setIsRefresh] = useState(0);

  const handleSetSearchingData = (data) => {
    setSearchingData(data);
  };

  return (
    <SearchingDataContext.Provider
      value={{ searchingData, handleSetSearchingData, isRefresh, setIsRefresh }}
    >
      {children}
    </SearchingDataContext.Provider>
  );
};
